import React from 'react';
import { object } from 'prop-types';
import withUser from 'util/hoc/with-user';
import { withRouter } from 'library/util/core-router';
import styled from 'styled-components';
import {
  StyledApprovalSection,
  StyledApprovalRow,
  StyledApprovalStatus,
} from '../approval-status';
import { getApprovalStatusString } from '../org-approval-options';

const StyledApprovalStatusMessage = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  z-index: 1;
`;

const OrgApprovalStatus = withUser(({ record: org, userRecord, user }) => {
  return (
    <StyledApprovalSection>
      <StyledApprovalRow key={`${org.id}_${userRecord.uuid}`}>
        {user?.uuid === userRecord.uuid ? (
          <StyledApprovalStatus>You</StyledApprovalStatus>
        ) : (
          <StyledApprovalStatusMessage>
            {getApprovalStatusString(org.professional, org)}
          </StyledApprovalStatusMessage>
        )}
      </StyledApprovalRow>
    </StyledApprovalSection>
  );
});

OrgApprovalStatus.propTypes = {
  record: object,
  user: object,
};

export default withRouter(OrgApprovalStatus);
